import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Problem from "@/components/Problem";
import Solution from "@/components/Solution";
import InteractiveDemo from "@/components/InteractiveDemo";
import TaintGraph from "@/components/TaintGraph";
import ComparisonTable from "@/components/ComparisonTable";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

function LandingPage() {
  return (
    <div className="min-h-screen bg-[#050508]">
      <Navbar />
      <Hero />
      <Problem />
      <Solution />
      <InteractiveDemo />
      <TaintGraph />
      <ComparisonTable />
      <ContactForm />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
